module.exports = __webpack_public_path__ + "img/headband.864cc18a.png";